import { createPortal } from 'react-dom';

/**
 * Creates a portal for server-side rendering.
 * @param {React.ReactNode} children - The children to render in the portal.
 * @param {HTMLElement|null} container - The container to render the portal into.
 * @returns {React.ReactPortal|null} - The created portal or null if the container is null.
 */
const createPortalSSR = (children, container) => {
    if (container === null) {
        return null;
    }
    return createPortal(
        children,
        container,
    );
};

export default createPortalSSR;